import { Marked } from "marked";

const CLICK_TO_VIEW_STYLE =
  "color:#34b0cb !important; cursor:pointer; text-decoration:underline;";

const escapeAttr = (value = "") =>
  String(value).replace(/&/g, "&amp;").replace(/"/g, "&quot;");

const escapeText = (value = "") =>
  String(value).replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;");

const buildClickToView = (href = "") => {
  const safe = escapeAttr(String(href));
  return `<a href="${safe}" target="_blank" rel="noopener noreferrer" style="${CLICK_TO_VIEW_STYLE}">Click to view</a>`;
};

// Raw HTML anchor tags bypass marked's link pipeline — convert them to
// markdown link syntax first so they reach the custom renderer below.
const convertHtmlAnchors = (text) =>
  text.replace(
    /<a\b[^>]*?\bhref\s*=\s*["']([^"']+)["'][^>]*>[\s\S]*?<\/a>/gi,
    (_, href) => `[link](${href})`
  );

// CommonMark forbids whitespace adjacent to ** or __ delimiters, so
// "** text **" never boldens. Trim the inner leading/trailing spaces
// so marked treats them as valid strong spans.
//
// Match a whole span (delimiter → content → delimiter) and trim its inner
// content. The lazy [^*\n]+? / [^_\n]+? can't contain the delimiter char, so
// it pairs an opening delimiter with its own closing one and never bridges the
// gap between two separate spans on the same line — e.g. "**A** x **B**" stays
// two spans instead of collapsing into "**A x B**".
const trimInner = (open) => (match, inner) => {
  const trimmed = inner.trim();
  return trimmed ? `${open}${trimmed}${open}` : match;
};

const normalizeBold = (text) =>
  text
    .replace(/\*\*([^*\n]+?)\*\*/g, trimInner("**"))
    .replace(/__([^_\n]+?)__/g, trimInner("__"));

const renderer = {
  // Handles: [text](url), bare GFM autolinks https://..., and <url> autolinks
  link({ href }) {
    // Emails (bare autolinks or mailto: links) stay plain text, never clickable.
    if (/^mailto:/i.test(href)) {
      return escapeText(href.replace(/^mailto:/i, ""));
    }
    return buildClickToView(href);
  },
};

// Single Marked instance — gfm enables autolinks, tables, and strikethrough;
// breaks converts single newlines to <br> (matches chat conventions).
const mdParser = new Marked({ gfm: true, breaks: true, renderer });

export default function renderAssistantMessage(rawContent) {
  if (rawContent === undefined || rawContent === null || rawContent === "") {
    return "";
  }
  const html = mdParser.parse(normalizeBold(convertHtmlAnchors(String(rawContent))));
  // "breaks: true" inserts a <br> when a URL appears on its own source line;
  // collapse it so "Click to view" stays inline with the preceding text.
  return html.replace(/<br\s*\/?>\s*(<a\b[^>]*>Click to view<\/a>)/gi, " $1");
}
